<template>
  <div id="error404" class="flex-align">
    <!-- 显示 loading 状态 -->
    <a-result status="info" title="Loading..." />
  </div>
</template>
<script>
import { ref, onMounted } from 'vue'
import { _user } from '@/api'
import { useRoute } from 'vue-router'
import { message } from 'ant-design-vue'
export default {
  setup(props, ctx) {
    const loading = ref(false) // 添加 loading 状态
    const retryCount = ref(0) // 记录重试次数，防止无限重试
    const route = useRoute()
    onMounted(() => {
      const { kycId } = route.query
      console.log(kycId, 'kycId++++++++++++++++')
      downOwnerPath(kycId)
    })

    // 请求函数
    const downOwnerPath = async (value) => {
      loading.value = true // 开始加载
      try {
        const res = await _user.getRecognitionUrl({ kycId: value, info: (JSON.stringify(window.getMetaInfo())) }) // 请求数据
        console.log(res, 'getRecognitionUrl++++++++++')
        retryCount.value = 0 // 请求成功，重置重试次数
        if (res.data.resCode === '000000') {
          window.location.href = res.data.data
        } else {
          message.error('当前服务连接异常。请您重新扫描二维码完成身份验证。 感谢您对Most的信任与支持')
        }
        // window.open = res.data.data
      } catch (error) {
        message.error('当前服务连接异常。请您重新扫描二维码完成身份验证。 感谢您对Most的信任与支持')
        if (retryCount.value < 3) { // 如果失败，最多重试3次
          retryCount.value++
          downOwnerPath(value) // 递归调用重新发起请求
        } else {
          console.error('请求已重试 3 次，仍然失败')
        }
      } finally {
        loading.value = false // 请求完成，停止 loading
      }
    }

    return {
      loading, // 返回 loading 状态
      downOwnerPath
    }
  }

}
</script>

<style lang="less" scoped>
#error404 {
  justify-content: center;
  height: 100vh;
}
</style>
